import { createAction } from "@reduxjs/toolkit";

const FIRST_DATE_POPUP_TYPE = "firstDatePopup";

export const firstDatePopupActions = {
  confirmed: createAction(`${FIRST_DATE_POPUP_TYPE}/confirmedRequest`),
  cancelled: createAction(`${FIRST_DATE_POPUP_TYPE}/cancelledRequest`),
};
